import PartnerProfileModal from "./PartnerProfileModal";
export default PartnerProfileModal